<template>
  <div class="o-listing-card o-listing-card--portrait" data-equalizer-watch="listing-cards">

    <!-- Favourite Button -->
    <div class="simplefavorite-button-container">
      <button class="simplefavorite-button reverse fav-plugin o-favourite-button" :data-postid="content.id" data-siteid="1" data-groupid="1" data-favoritecount="2" style=""><i class="sf-icon-star-empty"></i></button>
    </div>

    <!-- Image -->
    <div class="o-listing-card-image-container">
      <div class="o-listing-card__picture u-bg-img" :style="'background-image: url('+content.listing_image+');'" aria-hidden="true" role="presentation" v-if="content.listing_image"></div>
      <div class="o-listing-card__picture u-bg-img" style="background-image: url('/wp-content/themes/visitwaterford/assets/images/default-image.png');" aria-hidden="true" role="presentation" v-else></div>
    </div>

    <!-- Content -->
    <div class="o-listing-card-content">

      <!-- Card Title -->
      <h3 class="o-listing-card__title"><a :href="content.listing_link" v-html="content.title"></a></h3>

      <!-- Card Categories -->
      <div class="o-listing-card__categories">
        <a :href="cat.link" v-for="(cat,key) of content.categories" v-if="key <= 5">
          <span v-html="cat.name"></span>
          <span v-if="key == Object.keys(content.categories).length - 1"></span>
          <span v-else-if="key == 5">...</span>
        </a>
      </div>

      <!-- Card Location -->
      <div class="o-listing-card__location" v-if="content.locations.length"><a :href="content.listing_link" v-for="location in content.locations.slice(0,1)">{{ location.name }}</a></div>

      <!-- Card Text -->
      <div class="o-listing-card__text" v-if="content.content.length" v-html="content.content"></div>
    </div>

    <!-- Card Bottom -->
    <div class="o-listing-card-bottom">
      <!-- Card Button -->
      <div class="o-listing-card-button-wrapper">
        <a :href="content.listing_link" class="button button--small o-listing-card__button">View</a>
      </div>
    </div>
  </div>
</template>

<script>

  export default {

    name: 'ListingCardPortrait',

    props: {
      content: {
        type: Object,
      }
    },

    mounted () {
      this.callFoundation();
    },

    methods: {
        // Renit foundation components
      callFoundation () {
        this.$nextTick(() => {
          $(this.$el).foundation();
        })
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/js/vue/vue-partials/listing-card--portrait.vue